/**
 * Sentry opcional en la web (ADR-0004): solo si VITE_SENTRY_DSN se definió al construir.
 * Sin DSN no se carga configuración alguna y `reportarError` es no-op.
 */
import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN;
export const sentryActivo = Boolean(dsn);

export function iniciarSentry(): void {
  if (!dsn) return;
  const version = import.meta.env.VITE_MG_VERSION;
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: version ? `mg-erp-web@${version}` : undefined,
    tracesSampleRate: 0,
    sendDefaultPii: false,
  });
}

export function reportarError(err: unknown, contexto?: Record<string, unknown>): void {
  if (!sentryActivo) return;
  Sentry.captureException(err, contexto ? { extra: contexto } : undefined);
}

export const ErrorBoundary = Sentry.ErrorBoundary;
